<template>
  <slot />
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, provide, reactive } from 'vue'

const props = defineProps({
  queries: {
    type: Object,
    required: true,
  },
})

const mediaQueries = reactive({})
const matchers = ref([])

function init() {
  for (const key in props.queries) {
    const query = props.queries[key]

    const matcher = window.matchMedia(query)
    const handler = (event) => {
      mediaQueries[key] = event.matches
    }

    // Using deprecated method because of Safari's poor support for addEventListener
    matcher.addListener(handler)
    mediaQueries[key] = matcher.matches
    matchers.value.push([matcher, handler])
  }
}

onMounted(() => {
  init()
})

onBeforeUnmount(() => {
  matchers.value.forEach(([matcher, listener]) => {
    matcher.removeListener(listener)
  })
})

provide('mediaQueries', mediaQueries)
</script>
